import {
  CLEAR_DASHBOARD_CALCULATOR_DATA,
  CLEAR_STORE,
  DISABLE_CHATBOT,
  LOAD_FREQUENT_TRANSACTIONS_FOR_DASHBOARD,
  LOAD_RECENT_TRANSACTIONS_FOR_DASHBOARD,
  LOAD_TRANSFER_SUMMARY_FOR_DASHBAORD,
  RFI_CMS_VALUE,
  RFI_LIST,
  SET_BENEFICIARY_DETAILS_FROM_DASHBOARD_TO_QUICKPAY,
  STORE_DASHBOARD_CALCULATOR_DATA,
  STORE_IS_NAVIGATED_FROM_DASHBOARD_INIT_TNFER,
  TOGGLE_IS_RFI_BANNER_VISIBLE,
  TRANSACTION_KYC_VALUE
} from '../../action-contants';

const INITIAL_STATE = {
  recentTransactionList: [],
  frequentTransactionList: [],
  beneficiaryDetailsFromDashboardToQuickpay: {},
  currencyDetailsFromDashboardToExistingFlow: {},
  transferSummary: {},
  rfiTransctionData: {},
  rfiList: [],
  rfiCmsData: {},
  dashboardCalculatorData: {},
  isNavigatedFromDashboardInitiateTransferClick: false,
  isRfiBannerVisible: false
};

export default function dashboardReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CLEAR_STORE: {
      return INITIAL_STATE;
    }

    case LOAD_RECENT_TRANSACTIONS_FOR_DASHBOARD: {
      return { ...state, recentTransactionList: action.data };
    }

    case LOAD_FREQUENT_TRANSACTIONS_FOR_DASHBOARD: {
      return { ...state, frequentTransactionList: action.data };
    }

    case SET_BENEFICIARY_DETAILS_FROM_DASHBOARD_TO_QUICKPAY: {
      return {
        ...state,
        beneficiaryDetailsFromDashboardToQuickpay: action.data
      };
    }

    case LOAD_TRANSFER_SUMMARY_FOR_DASHBAORD: {
      return { ...state, transferSummary: action.data };
    }
    case TRANSACTION_KYC_VALUE: {
      return { ...state, rfiTransctionData: action.data };
    }
    case RFI_CMS_VALUE: {
      return { ...state, rfiCmsData: action.data };
    }

    case TOGGLE_IS_RFI_BANNER_VISIBLE: {
      return {
        ...state,
        isRfiBannerVisible: action.data
      };
    }
    case RFI_LIST: {
      return { ...state, rfiList: action.data };
    }

    case DISABLE_CHATBOT: {
      return { ...state, disableAdam: action.data };
    }
    case STORE_IS_NAVIGATED_FROM_DASHBOARD_INIT_TNFER: {
      return { ...state, isNavigatedFromDashboardInitiateTransferClick: action.data };
    }
    case STORE_DASHBOARD_CALCULATOR_DATA: {
      return { ...state, dashboardCalculatorData: action.data };
    }
    case CLEAR_DASHBOARD_CALCULATOR_DATA: {
      return {
        ...state,
        dashboardCalculatorData: {},
        isNavigatedFromDashboardInitiateTransferClick: false
      };
    }
    default:
      return state;
  }
}
